import { camelCase } from 'lib/utils/objectSerializer';
import { MarketerAction } from './actions';
import {
  API_READ_ELIGIBILITY_ASSESSMENTS,
  API_READ_ELIGIBILITY_ASSESSMENTS_SUCCESS,
} from './actionTypes';
import { RestaurantAssessment } from './types';

export type MarketerState = {
  eligibilityAssessments: RestaurantAssessment[];
};

const initialState = {
  eligibilityAssessments: [],
};

export default function marketerReducer(
  state: MarketerState = initialState,
  action: MarketerAction,
): MarketerState {
  switch (action.type) {
    case API_READ_ELIGIBILITY_ASSESSMENTS:
      return {
        ...state,
        eligibilityAssessments: [],
      };

    case API_READ_ELIGIBILITY_ASSESSMENTS_SUCCESS: {
      const eligibilityAssessments: RestaurantAssessment[] = camelCase(
        action.payload,
      );

      return {
        ...state,
        eligibilityAssessments,
      };
    }
    default:
      return state;
  }
}
